<script>
  // @ts-check
  // eslint-disable-next-line no-unused-vars
  import * as Types from "../NewsLetter/newsLetterTypes";

  import FormView from "./FormView.svelte";
  import ConfirmationView from "./ConfirmationView.svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = "";

  /**
   * @type { "split" | "stacked" }
   */
  export let layout = "split";

  /**
   * The theme of the form component
   * @type {import('../../utilities/themes.js').ThemeName}
   */
  export let theme = "lightGrey";

  /**
   * Optional featured image
   * @type {import('../../types/shared.js').Image} Image
   */
  export let featuredImage = undefined;

  /** The title of the form component
   * @type {string}
   * */
  export let title = "";

  /**
   * The description of the form component
   * @type {string}
   */
  export let description = "";

  /**
   * Optional prop for handling form submission natively
   *
   * @type {Types.FormProps}
   * */
  export let formProps;

  /**
   * A list of form fields
   * @type {import("../../molecules/FormFields/FormField.svelte").FormFieldProps[]}
   */
  export let formFields = [];

  /**
   * a list of field groups
   * @type {{label: string, formFields: import("../../molecules/FormFields/FormField.svelte").FormFieldProps[]}[]}
   */
  export let formFieldGroups = [];

  /** @type {(event: CustomEvent) => any}*/
  export let onSubmit = () => undefined;

  /**
   * Indicates whether the form is currently being submitted
   * @type {boolean}
   */
  export let isSubmitting = false;

  /**
   * Indicates whether the form submission was successful
   * @type {boolean}
   */
  export let isFormSubmitSuccess = false;

  /**
   * The error message to display when the form submission fails
   * @type {string}
   */
  export let formSubmitErrorMessage = "";

  /**
   * Optional props for the confirmation view
   * @type {{title: string, subtitle: string, description: string, cta: import('../../types/shared.js').CTA}}
   * */
  export let confirmation;

  const transitionFadeInClass = "transition-all duration-[400ms] input-easing animate-fadeIn";
</script>

<div {id} class="relative w-full">
  {#if isFormSubmitSuccess}
    <div
      class="inset-0 z-[--stack-level-newsletter-confirmation] h-full w-full {transitionFadeInClass}"
    >
      <ConfirmationView
        {id}
        {layout}
        {theme}
        {featuredImage}
        title={confirmation?.title}
        subtitle={confirmation?.subtitle}
        description={confirmation?.description}
        cta={confirmation?.cta}
        {isFormSubmitSuccess}
      />
    </div>
  {:else}
    <div class="w-full {transitionFadeInClass}">
      <FormView
        {id}
        {layout}
        {theme}
        {featuredImage}
        {title}
        {description}
        {isSubmitting}
        {formSubmitErrorMessage}
        {formProps}
        {formFields}
        {formFieldGroups}
        {onSubmit}
      />
    </div>
  {/if}
</div>
